class CountdownDate {
    constructor() {
      this.startDate = "";
      this.startTime = "";
      this.endDate = "";
      this.endTime = "";
      this.second = 1000;
      this.minute = this.second * 60;
      this.hour = this.minute * 60;
      this.day = this.hour * 24;
    }
  
    /**
     * @param {*} data 
     * @param {*} selectors 
     * 
     * const time = {
     *  startDate: "DD/MM/YYYY",
     *  startTime: "HH:MM:SS",
     *  endDate: "DD/MM/YYYY",
     *  endTime: "HH:MM:SS",
     * }
     * 
     * const selectors = {
     *  main: "CSS Selector for countdown wrapper section",
     *  day: "CSS Selector for element with day value",
     *  hour: "CSS Selector for element with hour value",
     *  minute: "CSS Selector for element with minute value",
     *  seconds: "CSS Selector for element with seconds value" 
     * }
     */
    init(data, selectors) {
      this.startDate = data.startDate;
      this.startTime = data.startTime;
      this.endDate = data.endDate;
      this.endTime = data.endTime;
  
      const formatStart = this.formatDateUS(this.startDate, this.startTime);
      const formatEnd = this.formatDateUS(this.endDate, this.endTime);
      const formatNow = Date.now();
      const distanceFromStart = formatStart.time - formatNow;
      const distanceFromEnd = formatEnd.time - formatNow;
      const restDateEnd = this.getRestDate(distanceFromEnd);
  
      if (distanceFromStart < 0 && distanceFromEnd > 0) {
        this.renderCountdown(restDateEnd, selectors);
      } else if(distanceFromStart > 0 && distanceFromEnd > 0) {
        document.querySelector(selectors.main).style.display = 'none';
      }
    }
  
    /**
     * 
     * @param {Date : string} date 
     * @param {Time : string} time 
     * @returns Date formated for javascript oparations
     */
    formatDateUS(date, time) {
      const arrayDate = date.split("/");
      const arrayTime = time.split(":");
  
      return {
        formatDate: `${arrayDate[1]}/${arrayDate[0]}/${arrayDate[2]} ${arrayTime[0]}:${arrayTime[1]}:${arrayTime[2]}`,
        time: new Date(
          `${arrayDate[1]}/${arrayDate[0]}/${arrayDate[2]} ${arrayTime[0]}:${arrayTime[1]}:${arrayTime[2]}`
        ).getTime(),
        second: arrayTime[2],
        minutes: arrayTime[1],
        hour: arrayTime[0],
        day: arrayDate[0],
        month: arrayDate[1],
        year: arrayDate[2],
      };
    }
  
    /**
     * 
     * @param {Date} distance 
     * @returns Object with Day, Hour, Minutes and Second for ending de countdown
     */
    getRestDate(distance) {
      const restDate = {
        day: Math.floor(distance / this.day),
        hour: Math.floor((distance % this.day) / this.hour),
        minutes: Math.floor((distance % this.hour) / this.minute),
        seconds: Math.floor((distance % this.minute) / this.second),
      };
  
      return restDate;
    }
  
    /**
     * Render values
     * @param {*} restDateEnd 
     * @param {*} selectors 
     */
    renderCountdown(restDateEnd, selectors) {
      document.querySelector(selectors.day).innerHTML = restDateEnd.day<10?"0"+restDateEnd.day:restDateEnd.day;
      document.querySelector(selectors.hour).innerHTML = restDateEnd.hour<10?"0"+restDateEnd.hour:restDateEnd.hour;
      document.querySelector(selectors.minute).innerHTML = restDateEnd.minutes<10?"0"+restDateEnd.minutes:restDateEnd.minutes;
      document.querySelector(selectors.seconds).innerHTML = restDateEnd.seconds<10?"0"+restDateEnd.seconds:restDateEnd.seconds;
    }
  }
  
  const countBanner = new CountdownDate();
  
  